import classNames from "classnames";
import "./Background.css";

export type Props = {
    className?: string;
    children?: React.ReactNode;
    textColorInversable?: boolean;
};

function BaseBackground(baseClassName?: string) {
    return function Background(props: Props) {
        const { className, children, textColorInversable = false } = props;
        return (
            <div
                className={classNames(
                    "web-lib__background",
                    {
                        "text-text-inverse-primary": textColorInversable,
                    },
                    baseClassName,
                    className,
                )}
            >
                {children || null}
            </div>
        );
    };
}

const Background = {
    BookingBg01: BaseBackground("bg-background-booking-primary"),
    BookingBg02: BaseBackground("bg-background-booking-secondary"),
    BookingBg03: BaseBackground("bg-background-booking-tertiary"),
    BookingBg04: BaseBackground("bg-background-booking-quaternary"),
    ConversationsBg01: BaseBackground("bg-background-conversations-primary"),
    ConversationsBg02: BaseBackground("bg-background-conversations-secondary"),
    ConversationsBg03: BaseBackground("bg-background-conversations-tertiary"),
    ConversationsBg04: BaseBackground("bg-background-conversations-quaternary"),
    ChatBg01: BaseBackground("bg-background-chat"),
    DiscoverBg01: BaseBackground("bg-background-discover-primary"),
    DiscoverBg02: BaseBackground("bg-background-discover-secondary"),
    DiscoverBg03: BaseBackground("bg-background-discover-tertiary"),
    DiscoverBg04: BaseBackground("bg-background-discover-quaternary"),
    ProfileBg01: BaseBackground("bg-background-profile-primary"),
    ProfileBg02: BaseBackground("bg-background-profile-secondary"),
    ProfileBg03: BaseBackground("bg-background-profile-tertiary"),
    Membership: BaseBackground("bg-component-membership-background"),
    StartBg01: BaseBackground("bg-background-start"),
};

export default Background;
